import { getAppClient,isIosAnd } from '@/utils/commonUtils'


// 支付系统
export const paySystem = () => {
    const environment = getAppClient()
    const mobile = isIosAnd()
    const systemList = new Map()
    .set('APP', ['IOS', 'Android'])
    .set('IOS', '1')
    .set('Android','2')
    .set('MWEB','3')
    .set('JSAPI','4')
    .set('wxCode','8')
    const system = systemList.get(environment)
    if(Array.isArray(system)){
        return systemList.get(mobile)
    }else{
        return system;
    }
}

// 支付环境 
export const payIsWeixin = () => {
    let is_weixin;
    getAppClient() == 'JSAPI' ? is_weixin = '1' : is_weixin = '0' ;
    return is_weixin
}

// 支付类型
export const payType = () =>{
    // JSAPI--公众号支付、APP--app支付，MWEB--H5支付
    const environment = getAppClient()
    const payTypeList = new Map()
    .set('APP', 'app')
    .set('MWEB','H5')
    .set('JSAPI','JSAPI')
    .set('wxCode','H5')
    const payType = payTypeList.get(environment)
    
    return payType;
    
}

